module.exports = __webpack_public_path__ + "img/deng1.8b53673e.png";